export default {
  // Thủ trưởng từ chối duyệt
  CompanyDirectorReject: -2,
  // Kế toán trưởng từ chối duyệt
  CompanyChiefAccountantReject: -1,
  // Chờ thủ trưởng duyệt
  WaitingCompanyDirector: 2,
  // Thủ trưởng đã duyệt
  CompanyDirectorApproved: 3,
};
